// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"0946339b","379":"8b7bbce9","453":"af1517c1","623":"d8d95f0e","667":"ceced48a","897":"1f9a90f7"}[chunkId] + ".chunk.js";
};